import { SxProps } from '@mui/material'

export const backToTopButtonStyles: SxProps = {
  position: 'fixed',
  width: { xs: '40px' },
  height: { xs: '40px' },
  bottom: { xs: 100, md: 120 },
  transition: 'all ease-in-out 0.1s',
}
